var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error403"},[_c('error',{attrs:{"code":403,"title":"哎呀，出错了！您没有访问的页面的权限…"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }